import React from 'react'
import AdminContract from '../../../components/customer/adminContract/AdminContract'

const CustomerAdminContract = () => {
    return <AdminContract />
}

export default CustomerAdminContract
